import React, { useState } from 'react';
import { register } from '../Admin/Api.js';
import { useNavigate } from 'react-router-dom';
import './Register.css'; // Stelle sicher, dass du die CSS-Datei importierst

const Registrieren = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [chiffre, setChiffre] = useState('');
    const navigate = useNavigate();





    const handleRegister = async (e) => {
        e.preventDefault();
        setError(''); // Fehler zurücksetzen

        try {
            const data = await register(username, password, chiffre); // Registrierung anfordern

            if(data.hasWorked){
                alert("Registrierung erfolgreich! ", + data.info)
                navigate('/login');
            } else {
                setError(data.info); // Fehlernachricht anzeigen        
            }
        } catch (err) {
            
        }
    };

    return (
        <div className="register-container"> {/* Füge eine Klasse hinzu für das Styling */}
            <h2>Registrieren</h2>
            <form onSubmit={handleRegister}>
                <label>Benutzername</label>
                <input
                    type="text"
                    placeholder='Benutzername'
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <label>Passwort</label>
                <input
                    type="password"
                    placeholder='Passwort'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <label>Einmalcode</label>
                <input
                    type="chiffre"
                    placeholder='Einmalcode'
                    value={chiffre}
                    onChange={(e) => setChiffre(e.target.value)}
                    required
                />
                <button type='submit'>Registrieren</button>
            </form>
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
};

export default Registrieren;
